import { defineMessages } from 'react-intl'

export default defineMessages({
  modalTitlePaymentPending: {
    id: 'modalTitlePaymentPending',
    defaultMessage: 'Sending Payment',
  },
  modalBodyPaymentPending: {
    id: 'modalBodyPaymentPending',
    defaultMessage: 'We are processing your payment.',
  },
  modalTitlePaymentFailed: {
    id: 'modalTitlePaymentFailed',
    defaultMessage: 'Payment Failed',
  },
  modalBodyPaymentFailed: {
    id: 'modalBodyPaymentFailed',
    defaultMessage: 'Sorry, your payment was not successful.\nPlease try processing the order again.',
  },
  modalTitlePaymentSuccessful: {
    id: 'modalTitlePaymentSuccessful',
    defaultMessage: 'Payment Successful',
  },
  modalBodyPaymentSuccessful: {
    id: 'modalBodyPaymentSuccessful',
    defaultMessage: 'Thank you! Your order was successfully submitted.',
  },
  continue: {
    id: 'continue',
    defaultMessage: 'Continue',
  },
})
